import React from "react"
import config from "./config.js"
import Layout from "./src/components/Layout"
import Providers from "./src/providers/providers"
import { initBraze } from "./src/lib/braze"

export const onClientEntry = () => {
  try {
    initBraze({
      apiKey: process.env.GATSBY_BRAZE_API_KEY,
      apiUrl: process.env.GATSBY_BRAZE_API_URL,
      market: config.store?.locationRegion,
    })
  } catch (e) {
    // no-op
  }
}

export const wrapRootElement = ({ element }) => <Providers>{element}</Providers>

export const wrapPageElement = ({ element, props }) => (
  <Layout {...props} settings={config.settings}>
    {element}
  </Layout>
)

export const onRouteUpdate = props => {
  const { location, prevLocation } = props
  if (
    location?.pathname !== prevLocation?.pathname &&
    /collection|search/.test(location?.pathname) &&
    /collection|search/.test(prevLocation?.pathname)
  )
    window.dispatchEvent(new Event("refreshSearch"))

  window.previousPath = prevLocation?.href || document.referrer
}
